/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {getUserData} from '@common'
import {UserRole} from '@enums'

import {useQuery} from '@tanstack/react-query'

import {getCompanyById, getAllCompanies} from './api'
import {companyKeys} from './keys'
import {CompanyResponse} from './types'

export const useCompanies = () => {
  return useQuery<CompanyResponse[], unknown>({
    queryKey: companyKeys.list(),
    queryFn: async () => {
      const currentUser = getUserData()

      if (currentUser.role === UserRole.SUPER_ADMIN) {
        return getAllCompanies()
      }

      return Promise.all(currentUser.companyIds.map(id => getCompanyById(id)))
    },
  })
}

export const useCompany = (id?: string) => {
  return useQuery<CompanyResponse, unknown>({
    queryKey: companyKeys.detail(id || ''),
    queryFn: () => getCompanyById(id!),
    enabled: !!id,
  })
}
